import { ApiClient } from '@provider-portal/common/api';
import { ConfigType } from '@provider-portal/common/config';
import { EventAliasingService } from '@provider-portal/common/services/EventAliasingService';
import { MixpanelService } from '@provider-portal/common/services/MixpanelService';
import { checkProductionMode } from '@provider-portal/common/utils/environment';
import { Middleware } from 'redux';
import { createLogger, type LoggerPredicate } from 'redux-logger';
import { createEpicMiddleware } from 'redux-observable';

import { EpicDependenciesCredentialsVariant } from '@bolteu/redux-session';

import { ApplicationUpdateService } from 'services/ApplicationUpdateService';

export interface AppServices extends EpicDependenciesCredentialsVariant {
  apiClient: ApiClient;
  config: ConfigType;
  mixpanelService: MixpanelService;
  eventAliasingService: EventAliasingService;
  applicationUpdateService: ApplicationUpdateService;
}

const isProductionMode = checkProductionMode();

const shouldCollapse: LoggerPredicate = (_getState, action) => {
  return !action.reason;
};

export const createMiddleware = (middlewareDeps: AppServices) => {
  const logger = createLogger({
    duration: true,
    timestamp: false,
    collapsed: shouldCollapse,
  });

  const epicMiddleware = createEpicMiddleware({
    dependencies: middlewareDeps,
  });

  const allMiddlewares: Middleware[] = [epicMiddleware];
  // Push debugging middlewares
  if (!isProductionMode) {
    allMiddlewares.push(logger as Middleware);
  }

  return { allMiddlewares, epicMiddleware };
};
